const config = {
  IS_ONLINE_URL:process.env.VUE_APP_IS_ONLINE_URL,
  STORAGE_KEYS:{
    TOKEN:"arch-pms-token",
    PREV_PAGE: "prev",
    NEXT_PAGE:"next"
  },
  // Sentec Websocket / PubSub
  ST_WEBSOCKET_PUBSUB: process.env.VUE_APP_SENTEC_PUBSUB_URL, // Websocket url
  // Sentec file storage endpoints
  ST_STORAGE_STATIC_URL: process.env.VUE_APP_STORAGE_STATIC_URL, // Uploaded files (all)
  // Sentec API
  ST_API_BASE: process.env.VUE_APP_API_APP_URL, // Base App endpoint
  ST_API_ACCOUNT: process.env.VUE_APP_API_ACCOUNT_URL, // Account endpoints
  ST_API_FINANCE: process.env.VUE_APP_API_FINANCE_URL, // Finance endpoints
  ST_API_FO: process.env.VUE_APP_API_FO_URL, // Front-office endpoints
  ST_API_POS: process.env.VUE_APP_API_POS_URL, // POS endpoints
  // Sentec web apps
  ST_WEB_Account: process.env.VUE_APP_WEB_ACCOUNT_URL, // Web account
  ST_WEB_Finance: process.env.VUE_APP_WEB_FINANCE_URL, // Web finance
  ST_WEB_FO: process.env.VUE_APP_WEB_FO_URL, // Web front-office
  ST_WEB_POS: process.env.VUE_APP_WEB_POS_URL, // Web pos

  ST_STORAGE_POS: process.env.VUE_APP_STORAGE_POS, // POS related image / doc
};

export default config;
